import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "climb-up",
  "use": "climb-up-usage",
  "viewBox": "-2 -6 24 24",
  "content": "<symbol viewBox=\"-2 -6 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"climb-up\">\r\n<path d=\"M14 0L16.29 2.29L11.41 7.17L7.41 3.17L0 10.59L1.41 12L7.41 6L11.41 10L17.71 3.71L20 6V0H14Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol